import _extends from "@babel/runtime/helpers/extends";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { forwardRef } from "react";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { OptionBaseStyled } from "./OptionBaseStyled";
export var OptionBase = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$height;
  var themeMode = useCombinedThemeMode();
  var optionHeight = (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : menuTheme.optionHeight.normal(themeMode);
  return /*#__PURE__*/React.createElement(OptionBaseStyled, _extends({}, props, {
    height: optionHeight,
    themeMode: themeMode,
    ref: ref
  }));
});
OptionBase.displayName = "OptionBase";
//# sourceMappingURL=OptionBase.js.map